import { reflect } from '@effector/reflect';
import { Select } from '@mantine/core';
import { combine } from 'effector';
import { useUnit } from 'effector-react';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { $t, translated } from 'shared/lib';
import { createModalForm } from 'shared/ui';
import { AddWalletModel } from '../../model';
import cls from './add-wallet-modal.module.scss';

export const createAddWalletModal = (model: AddWalletModel) => {
	const ModalForm = createModalForm(model);

	const CurrencyField = reflect({
		view: Select,
		bind: {
			'data-test-id': 'add-wallet-currency-select',
			label: translated('add-wallet.currency'),
			placeholder: translated('add-wallet.currency'),
			data: model.$availableCurrencies,
			value: model.form.fields.currency.$value,
			onChange: model.form.fields.currency.setValue,
			errorProps: { 'data-test-id': 'add-wallet-currency-select-error' },
			error: combine(
				[model.form.fields.currency.$errors, $t],
				([errors, t]) =>
					errors.length > 0 &&
					t(`errors:validation.${errors[0]}`, {
						fieldName: t('add-wallet.currency'),
					}),
			),
		},
	});

	const AddWalletModalButton = reflect({
		view: ModalForm.Button,
		bind: {
			'data-test-id': 'add-wallet-button',
			leftSection: <Plus />,
			className: cls.addWalletModalButton,
			disabled: model.$disabled,
			children: translated('add-wallet.label'),
			modalData: null,
		},
	});

	const AddWalletModal = () => {
		const { t } = useTranslation();

		const pending = useUnit(model.$pending);

		return (
			<ModalForm
				title={t('add-wallet.title')}
				cancelButtonProps={{
					children: t('add-wallet.cancel'),
				}}
				submitButtonProps={{
					children: t('add-wallet.add'),
					loading: pending,
				}}
			>
				<CurrencyField />
			</ModalForm>
		);
	};

	return Object.assign(AddWalletModal, {
		Button: AddWalletModalButton,
	});
};
